// extracted by mini-css-extract-plugin
export default {"wrapper":"PlanningSkeleton_wrapper_sLJ5G"};